import { Injectable } from '@angular/core';
import { ServiceBase } from './servicebase.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { take } from 'rxjs';
import { MessageService } from 'primeng/api';
import { LoaderService } from './loader.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService extends ServiceBase {

  constructor(protected http: HttpClient,
    public messageService: MessageService,
    protected loaderService: LoaderService) {
    super(http, messageService);
  }

  public getOktaRefreshingToken() {

    if (sessionStorage.getItem(environment.authRefreshTokenStorageKey) !== null) {

      let currentRefreshToken = sessionStorage.getItem(environment.authRefreshTokenStorageKey);

      let data = {
        'refreshtoken': currentRefreshToken
      }
      return this.http.post<ServerModels.LoginReponse>(`${this.apiRoot}/api/Okta/requestrefreshtoken`, data, {
        headers:
          new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          })
      }).pipe(take(1)).subscribe({
        next: (auth: ServerModels.LoginReponse) => {
          if (auth != null) {
            sessionStorage.removeItem(environment.authTokenStorageKey);
            sessionStorage.removeItem(environment.authTokenExpiresStorageKey);
            sessionStorage.removeItem(environment.authRefreshTokenStorageKey);

            let tokenExpiresIn = Date.now() + auth.ExpiresAt * 1000
            sessionStorage.setItem(environment.authRefreshTokenStorageKey, auth.RefreshToken);
            sessionStorage.setItem(environment.authTokenStorageKey, auth.AccessToken);
            sessionStorage.setItem(environment.authTokenExpiresStorageKey, tokenExpiresIn.toString());
            this.startRefreshTokenTimer();
          }
          this.loaderService.status$.next(false);
        },
        error: (err: any) => this.loaderService.status$.next(false)
      });
    }
    return null;
  }

  public refreshingToken() {

    if (sessionStorage.getItem(environment.authRefreshTokenStorageKey) !== null) {

      let currentRefreshToken = sessionStorage.getItem(environment.authRefreshTokenStorageKey);

      let data = `refresh_token=${currentRefreshToken}&grant_type=refresh_token&client_id=${environment.authTokenClientId}`;
      return this.http.post(`${this.apiRoot}/token`, data, {
        headers:
          new HttpHeaders({
            'Content-Type': 'application/x-www-form-urlencoded'
          })
      }).pipe(take(1)).subscribe({
        next: (auth: any) => {
          if (auth != null) {
            sessionStorage.removeItem(environment.authTokenStorageKey);
            sessionStorage.removeItem(environment.authTokenExpiresStorageKey);
            sessionStorage.removeItem(environment.authRefreshTokenStorageKey);

            sessionStorage.setItem(environment.authRefreshTokenStorageKey, auth.refresh_token);
            sessionStorage.setItem(environment.authTokenStorageKey, auth.access_token);
            sessionStorage.setItem(environment.authTokenExpiresStorageKey, Date.parse(auth.ExpiresAt.toString()).toString());
            this.startRefreshTokenTimer();
          }
          this.loaderService.status$.next(false);
        },
        error: (err:any) => this.loaderService.status$.next(false)
      });
    }
    return null;
  }

  private refreshTokenTimeout: NodeJS.Timeout;

  public startRefreshTokenTimer() {
    if (sessionStorage.getItem(environment.authRefreshTokenStorageKey) !== null) {
      let tokenExpires: number = Number.parseInt(sessionStorage.getItem(environment.authTokenExpiresStorageKey));
      // set a timeout to refresh the token a minute before it expires
      const timeout = tokenExpires - Date.now() - (60 * 1000);
      this.refreshTokenTimeout = setTimeout(() => {
        //console.log("Refresh Token " + timeout);
        this.getOktaRefreshingToken();
      }, timeout);
    }
  }

  public stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }
}
